import { Helmet } from 'react-helmet-async';
import React from 'react';
import ChangeInsightsSurveyContainer from '../../../containers/change-insights/ChangeInsightsSurveyContainer.jsx';
import requireAuth from '../../../lib/requireAuth.jsx';
import withRouterParams from '../../../lib/withRouterParams.jsx';

const TemplatePreview = ({ templateId, slug }) => {
  return (
    <>
      <Helmet>
        <title>Feedback Form | ChangeSync</title>
      </Helmet>
      <ChangeInsightsSurveyContainer
        templateId={templateId}
        isPreviewTemplate
        slug={slug}
      />
    </>
  );
};

export default requireAuth(withRouterParams(TemplatePreview));
